// src/frontend/src/utils/AuthUtils.js
import { config } from "../Constants";

export const openOAuthPopup = (loginSuccessCallback, redirectPath) => {
    // Store redirect path if provided
    if (redirectPath) {
        localStorage.setItem('redirectAfterLogin', redirectPath);
    }

    // Optimal popup dimensions
    const width = 500;
    const height = 650;
    const left = window.screenX + (window.outerWidth - width) / 2;
    const top = window.screenY + (window.outerHeight - height) / 2.5;

    // Use the current origin for the redirect URI
    const currentOrigin = window.location.origin;
    const redirectUri = `${currentOrigin}/oauth2/redirect`;

    const URL = config.url;
    const url = `${URL}/oauth2/authorize/google?redirect_uri=${encodeURIComponent(redirectUri)}`;

    // Open popup with proper positioning and features
    const popup = window.open(
        url,
        'Login with Google',
        `width=${width},height=${height},left=${left},top=${top},toolbar=0,scrollbars=1,status=1,resizable=1,location=1,menuBar=0`
    );

    if (!popup) {
        console.error("Popup blocked. Please allow popups for this site.");
        alert("Please allow popups to continue with Google login.");
        return;
    }

    if (popup && popup.focus) {
        popup.focus();
    }
    
    // List of trusted origins for message exchange
    const allowedOrigins = [
        'http://localhost:3000', 
        'http://stockmaid.com:3000',
        'http://stockmaid.com:8080',
        'https://stockmaid.com'
    ];
    
    // Handle message events from the popup
    const handleMessage = (event) => {
        
        // Verify trusted origin
        if (!allowedOrigins.some(origin => event.origin.startsWith(origin))) {
            console.warn("Received message from unauthorized origin:", event.origin);
            return;
        }

        // Process authentication result
        if (event.data && event.data.type === 'oauth2_success') {
            const token = event.data.token;
            
            // Call the loginSuccess callback directly
            if (loginSuccessCallback && token) {
                loginSuccessCallback(token).then(success => {
                    if (success) {
                        // Handle redirection after successful login
                        const savedRedirect = localStorage.getItem('redirectAfterLogin');
                        if (savedRedirect) {
                            localStorage.removeItem('redirectAfterLogin');
                            window.location.href = savedRedirect;
                        } else {
                            // Only reload if not redirecting elsewhere
                            window.location.reload();
                        }
                    }
                });
            }
            
            // Clean up event listener
            window.removeEventListener('message', handleMessage);
        }
        
        // Handle authentication errors
        if (event.data && event.data.type === 'oauth2_error') {
            console.error('Authentication error:', event.data.error);
            
            // Display error to user
            alert(`Authentication failed: ${event.data.message || 'Unknown error'}`);
            
            // Clean up event listener
            window.removeEventListener('message', handleMessage);
        }
    };

    // Add event listener
    window.addEventListener('message', handleMessage);
    
    // Add popup timeout (5 minutes)
    setTimeout(() => {
        if (popup && !popup.closed) {
            popup.close();
            console.warn("Login popup timed out");
            window.removeEventListener('message', handleMessage);
        }
    }, 5 * 60 * 1000);
    
    // Return a function that can be used to cleanup
    return () => {
        window.removeEventListener('message', handleMessage);
        if (popup && !popup.closed) {
            popup.close();
        }
    };
};